import React from "react";

function Called() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 48 48"
    >
      <g data-name="22 call">
        <path
          fill="#8ee16a"
          d="M24 12a12 12 0 018.48 3.52l2.18-.18.65-2.65A16 16 0 0024 8zm0 8a4 4 0 012.83 1.17l2.56-.55.26-2.27A7.94 7.94 0 0024 16z"
          data-original="#8ee16a"
        ></path>
        <path
          fill="#453d81"
          d="M18.19 16.94a6 6 0 00-1.45-6.14L10 4.06l-7.07 7.07a10 10 0 000 14.14l9.9 9.9 5.73-3.73 2.75-4.75-4.78-4.79z"
          data-original="#453d81"
        ></path>
        <path
          fill="#2d2755"
          d="M22.73 45.07a10 10 0 0014.14 0L43.94 38l-6.74-6.74a6 6 0 00-6.14-1.45l-5 1.66-4.79-4.78-8.48 8.48z"
          data-original="#2d2755"
        ></path>
        <path
          fill="#00ca76"
          d="M28 24h4a7.94 7.94 0 00-2.35-5.65l-2.82 2.82A4 4 0 0128 24zm8 0h4a16 16 0 00-4.69-11.31l-2.83 2.83A12 12 0 0136 24z"
          data-original="#00ca76"
        ></path>
        <path
          fill="#8ee16a"
          d="M24 0v4a20 20 0 0114.14 5.86l2.42-.42L41 7a23.89 23.89 0 00-17-7z"
          data-original="#8ee16a"
        ></path>
        <path
          fill="#00ca76"
          d="M48 24a23.89 23.89 0 00-7-17l-2.86 2.86A20 20 0 0144 24z"
          data-original="#00ca76"
        ></path>
      </g>
    </svg>
  );
}

export default Called;
